// src/plugins/lodash.js
import _ from 'lodash'

export default {
  // install (app) {
  //   // 注册完整的 lodash 实例
  //   app.config.globalProperties._ = _

  //   // 可选：注册快捷方法
  //   app.config.globalProperties.$debounce = (fn, wait) => _.debounce(fn, wait)
  //   app.config.globalProperties.$throttle = (fn, wait) => _.throttle(fn, wait)
  // }
}
